<div class="form-group" *ngIf="questionModel.visible !== false">
  <div class="custom-control-wrapper" [formGroup]="form"
       [ngClass]="{'form-control-without-error' : !hasErrors(),
        'form-control-with-error' : hasErrors()}">
    <div
      class="sd-element__title sd-question__title sd-question__title--answer sd-question__title--required sd-title"
      *ngIf="questionModel.title">
      <p class="mb-0" [ngClass]="{'pb-3' : !questionModel.description}">
        <span>{{ questionModel.title }}</span>
        <span class="required-control" *ngIf="questionModel.isRequired">*</span>
      </p>
      <div class="sd-question__description--under-input" *ngIf="questionModel.description">
        <span class="sv-string-viewer question-hint" style="position: static;">{{ questionModel.description }}</span>
      </div>
    </div>

    <div *ngFor="let choice of questionModel.choices"
         class="sd-item sd-checkbox sd-selectbase__item"
         [ngClass]="{'sd-item--checked sd-checkbox--checked': isSelected(choice.value),
         'sd-item--allowhover sd-checkbox--allowhover': !isSelected(choice.value)}"
         role="presentation">
      <label class="sd-selectbase__label">
        <input class="sd-visuallyhidden sd-item__control sd-checkbox__control"
               type="checkbox"
               [checked]="isSelected(choice.value)"
               [disabled]="choice.disabled"
               (change)="onCheckboxChange(choice.value, $event.target)">
        <span class="sd-item__decorator sd-checkbox__decorator"
              [ngClass]="{
        'form-control-background-error': hasErrors()
        }">
        <svg class="sd-item__svg sd-checkbox__svg">
          <use xlink:href="#icon-check-16x16"></use>
        </svg>
      </span>
        <span class="sd-item__control-label">
        <span class="sv-string-viewer">{{ choice.text }}</span>
      </span>
      </label>
    </div>
  </div>
</div>

<div class="sd-element__erbox sd-error sd-question__erbox sd-question__erbox--below-question" *ngIf="hasErrors()">
  <div class="sd-question__erbox-message">
    {{ getErrorMessage() }}
  </div>
</div>
